import { render, staticRenderFns } from "./GZ.vue?vue&type=template&id=4348cf19&scoped=true"
import script from "./GZ.vue?vue&type=script&lang=js"
export * from "./GZ.vue?vue&type=script&lang=js"
import style0 from "./GZ.vue?vue&type=style&index=0&id=4348cf19&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4348cf19",
  null
  
)

export default component.exports